import classes from "./TextArea.module.scss";
import { clsx } from "clsx";

interface IProps {
  label?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (event: any) => void;
  value: string | number;
  error?: string;
  rows?: number;
  disabled?: boolean;
  placeholder?: string;
}
export const TextArea = ({ label, value = "", onChange, error, disabled, placeholder, rows = 3 }: IProps) => {
  return (
    <div>
      { label && <label className={classes.Label}>{label}</label> }

      <textarea
        rows={rows}
        className={clsx(classes.Input, { [classes.HasError]: !!error })}
        onChange={onChange}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
      ></textarea>

      { error && <div className={classes.Error}>{error}</div> }
    </div>
  );
};
